import { useEffect, useRef, useState } from 'react';

export function useDelayedLoopToggle(
  shouldLoop: boolean,
  animationSpeed: number
) {
  const pendingLoopRef = useRef<NodeJS.Timeout | null>(null);
  const [isLoopActive, setIsLoopActive] = useState(shouldLoop);

  useEffect(() => {
    if (isLoopActive === shouldLoop) {
      return;
    }

    function cleanPreviousTask() {
      if (pendingLoopRef.current) {
        clearTimeout(pendingLoopRef.current);
        pendingLoopRef.current = null;
      }
    }

    cleanPreviousTask();

    // Change loop only after animation
    pendingLoopRef.current = setTimeout(() => {
      setIsLoopActive(shouldLoop);
      pendingLoopRef.current = null;
    }, animationSpeed);

    return cleanPreviousTask;
  }, [shouldLoop, isLoopActive, animationSpeed]);

  return isLoopActive;
}
